import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import Swal from 'sweetalert2'
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { InstantiateExpr } from '@angular/compiler';
const moment = _rollupMoment || _moment;

declare var $: any;
@Component({
  selector: 'Hrms',
  templateUrl: './targetMaster.component.html',
})
export class TargetMasterComponent implements OnInit {
  employeeData: any;
  prjId: any;
  userId: any;
  showLoader: boolean
  yearList: any;
  monthList: any;
  zoneList: any;
  categoryList: any;
  measure: any;
  measureModal: any;
  monthName: any;
  yearName: any;
  zoneName: any;
  categoryId: any;
  zoneModal: any;
  categoryModal: any;
  targetModal: any;
  performanceTargetList: any;
  targetMsg: any;
  targetSuccess = false;
  targetError = false;
  monthModal: any;
  yearModal: any;
  zoneDefaultId: any;
  targetPopup: any;
  targetDataList: any;
  monthId: any;
  yearId: any;
  previousTargetList: any;
  actionStatus: any;
  tblIndex: any;
  isSubmtActive = false;
  constructor(private http: HttpClient, private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

  /*
    * Get Employee List
    */
  getTargetList() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'admin/getTargetPerformance?prjId=' + this.prjId).subscribe((data) => {
      this.performanceTargetList = data;
      this.loaderService.display(false);
    });
  }
  /*
  GET YEAR LIST
  */
  getYearList() {
    this.http.get(environment.apiUrl + 'admin/getYearList').subscribe((data) => {
      this.yearList = data;
    });
  }
  /*
  GET YEAR LIST
  */
  getMonthList() {
    this.http.get(environment.apiUrl + 'admin/getMonthList').subscribe((data) => {
      this.monthList = data;
    });
  }

  /*
  * Get Zone By Prj Id
  */
  getZoneByProject(prjid) {
    this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=' + prjid + '&oemid=7').subscribe(data => {
      this.zoneList = data;
    });
  }

  /*
  * Get Zone By Prj Id
  */
  getPformCategory() {
    this.http.get(environment.apiUrl + 'admin/getpFormCategoryList?prjId=' + this.prjId).subscribe(data => {
      this.categoryList = data;
      this.bindTargetPopup();
    });
  }
  public restrictNumericOnly(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }


  /*
   * Select Year
  */
  selectYear(data) {
    this.yearName = data.YEARS
    // console.log("data",this.yearName)
    this.getPreviousTarget(this.monthModal, this.yearModal, this.zoneModal)
  }

  /*
  * Select ZONE
  */
  selectZone(data) {
    this.zoneName = data.id
    this.getPreviousTarget(this.monthModal, this.yearModal, this.zoneName)
  }

  /*
  * Select Month
  */
  selectMonth(data) {
    if (this.yearModal == null) {
      alert("First Select Month")
      return;
    }
    if (this.zoneModal == null) {
      alert("First Select zone")
      return;
    }
    this.monthName = data.ID
    this.getPreviousTarget(this.monthName, this.yearModal, this.zoneModal)
  }

  /*
   * GET MESURMENT ON CATEGORY SELECTION
   */
  selectCategory(data) {
    this.measure = data.MEASURE
    this.measureModal = data.MEASURE
  }



  bindTargetPopup() {
    this.targetPopup = []
    for (var i = 0; i < this.categoryList.length; i++) {
      this.targetPopup.push({ ID: 1, CATEGORYID: this.categoryList[i].ID, category: this.categoryList[i].CATEGORY, TARGET: "", lastTarget: "" })
    }
  }

  mergeTargetData() {
    for (var i = 0; i < this.targetPopup.length; i++) {
      this.targetPopup[i].PRJID = this.prjId;
      this.targetPopup[i].ZONEID = this.zoneModal;
      this.targetPopup[i].MONTH = this.monthModal;
      this.targetPopup[i].YEAR = this.yearModal;
      this.targetPopup[i].USERID = this.userId
      this.targetPopup[i].ID = this.actionStatus;
    }
  }


  /*
   * To open Modal poup with Category
   */
  Addtargetbtn(statusId) {
    this.monthModal = null;
    this.yearModal = null;
    this.zoneModal = null;
    this.targetPopup = []
    this.targetSuccess = false;
    this.targetError = false;
    this.actionStatus = statusId
    for (var i = 0; i < this.categoryList.length; i++) {
      this.targetPopup.push({ ID: this.actionStatus, CATEGORYID: this.categoryList[i].ID, category: this.categoryList[i].CATEGORY, TARGET: "", lastTarget: "" })
    }
    $('#targetViewModal').modal('show');
  }



  /*
   * To open Modal for Row View click event
   */
  targetViewbtn(data, statusId) {
    this.monthId = data.MONTH
    this.yearId = data.YEAR
    this.monthModal = this.monthId
    this.yearModal = this.yearId
    this.zoneModal = data.ZONEID
    this.actionStatus = statusId
    this.targetSuccess = false;
    this.targetError = false;
    this.http.get(environment.apiUrl + 'admin/getPreviousTargetList?prjId=' + this.prjId + '&monthId=' + this.monthId + '&year=' + this.yearId + '&zoneId=' + this.zoneModal).subscribe(data => {
      this.previousTargetList = data;
      if (this.previousTargetList.length > 0) {
        this.targetPopup = [];
        for (var i = 0; i < this.previousTargetList.length; i++) {
          this.targetPopup.push({ ID: this.actionStatus, CATEGORYID: this.previousTargetList[i].CATEGORYID, category: this.previousTargetList[i].CATEGORY, TARGET: this.previousTargetList[i].CURRENT_TARGET, lastTarget: this.previousTargetList[i].PREVIOS_TARGET })
        }
      }
    });
    $('#targetViewModal').modal('show');
  }

  /*
  * To get Target Data by month and year wise
  */
  getTargetData(monthId, year) {
    this.http.get(environment.apiUrl + 'admin/getTargetData?prjId=' + this.prjId + '&monthId=' + monthId + '&year=' + year).subscribe(data => {
      this.targetDataList = data;
      this.targetPopup = [];
      for (var i = 0; i < this.targetDataList.length; i++) {
        this.targetPopup.push({ ID: 0, CATEGORYID: this.categoryList[i].ID, category: this.categoryList[i].CATEGORY, TARGET: this.targetDataList[i].TARGET, lastTarget: "" })
      }
    });
  }

  /*
   * To get previous month Target Data by month, year and zoneId wise
   */
  getPreviousTarget(monthId, year, zoneId) {
    this.http.get(environment.apiUrl + 'admin/getPreviousTargetList?prjId=' + this.prjId + '&monthId=' + monthId + '&year=' + year + '&zoneId=' + zoneId).subscribe(data => {
      this.previousTargetList = data;
      if (this.previousTargetList.length > 0) {
        this.targetPopup = [];
        for (var i = 0; i < this.previousTargetList.length; i++) {
          this.targetPopup.push({ ID: 0, CATEGORYID: this.previousTargetList[i].CATEGORYID, category: this.previousTargetList[i].CATEGORY, TARGET: this.previousTargetList[i].CURRENT_TARGET, lastTarget: this.previousTargetList[i].PREVIOS_TARGET })
        }
      } else {
        this.targetPopup = [];
        for (var i = 0; i < this.categoryList.length; i++) {
          this.targetPopup.push({ ID: 0, CATEGORYID: this.categoryList[i].ID, category: this.categoryList[i].CATEGORY, TARGET: "", lastTarget: "" })
        }
      }
    });
  }





  targetValue(current) {
    // console.log("current",current) 
  }



  /*
  * To save Target Data
  */
  savePerformanceTargate() {
    this.mergeTargetData()
    this.isSubmtActive = true;
    this.http.post(environment.apiUrl + 'admin/savePerformanceTarget', this.targetPopup).subscribe(data => {
      var result: any
      result = data
      var resCode = result.output[0].RESPONSECODE
      if (resCode == 200) {
        this.targetSuccess = true;
        this.getTargetList()
        this.targetMsg = result.output[1].RESPONSEMESSAGE
        setTimeout(() => { this.targetSuccess = false; this.isSubmtActive = false; $('#targetViewModal').modal('hide') }, 2000);
        this.loaderService.display(false);
      } else {
        this.targetMsg = result.output[1].RESPONSEMESSAGE
        this.targetSuccess = false;
        this.targetError = true;
        this.loaderService.display(false);
        this.isSubmtActive = false
      }
    },
      error => {
        this.loaderService.display(false);
        this.isSubmtActive = false
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
        });
      })
  }

  ngOnInit(): void {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getTargetList();
    this.getZoneByProject(this.prjId);
    this.getYearList();
    this.getMonthList();
    this.getPformCategory();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/target/targetMaster/targetMaster.component.ts